<template>
  <div 
    id="header"
    class="ProjectBeknopt" 
    v-if="slug !== null && slug !== 'error' && projectData !== false">

    <!-- <BtnExtend extend :slug="slug" /> -->
    
    <HeaderSection 
      :title="`Project: ${title}`"
      :mediaImageSrc="afbeelding"
      :closeLinkTo="{name: 'list-projecten'}">
      <SimpleTable v-if="tableData.length" :data="tableData" />
    </HeaderSection>

    <ContentSection v-if="projectData.verhaal">
      <VueMarkdown :source="projectData.verhaal" :anchorAttributes="{ target: '_blank' }" />
    </ContentSection>
    <ContentSection v-if="partijen.length !== 0" >
      <SectionHeader label="BETROKKEN PARTIJEN" />
      <Tags :tags="partijen" />
      <!-- compact :limit="5" -->

      <!-- <Link 
        arrow
        label="Bekijk meer betrokken partijen"
        :to="{name: 'project-extended', params: { slug }}" /> -->
    </ContentSection>

    <ContentSection v-if="themas.length !== 0" >
      <SectionHeader label="THEMAS" />
      <Tags :tags="themas"  /> 
      <!-- compact :limit="5" -->

      <!-- <Link 
        arrow
        label="Bekijk meer thema's"
        :to="{ name: 'project-extended', params: { slug } }" /> -->
    </ContentSection>
    
  </div>
</template>

<script>
import Basis from './ProjectBasis';

// import Link from '@/components/Link';
// import BtnExtend from '@/components/buttons/Extend';
import SectionHeader from '@/components/section/Header';
import ContentSection from '@/components/section/ContentSection';
import HeaderSection from '@/components/section/HeaderSection';
import SimpleTable from '@/components/content/SimpleTable';
import Tags from '@/components/lists/Tags';

import VueMarkdown from 'vue-markdown'

export default {
  name: 'ProjectBeknopt',
  components: {
    // Link, 
    // BtnExtend,
    SectionHeader,
    ContentSection,
    HeaderSection,
    SimpleTable,
    Tags,
    VueMarkdown
  },
  extends: Basis,

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('extended_set', { extended: true })
      // vm.$store.dispatch('sidepanel_set', { panel: 'TimeLine' })
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('extended_set', { extended: false })
    // this.$store.dispatch('sidepanel_set', { panel: 'GlobalGoals' })
    next();
  }
}
</script>

<style lang="scss">
  .ProjectBeknopt {
    position: relative;
    display: flex;
    flex-direction: column;
  }
</style>
